import React from "react";
// nodejs library to set properties for components
import {withRouter} from 'react-router-dom';
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../../components/Grid/GridContainer.jsx";
import Button from "../../../../components/CustomButtons/Button";
import NotificationSuccessIcon from "@material-ui/icons/DoneAll";
import NotificationErrorIcon from "@material-ui/icons/Error";
import NotificationFailedIcon from "@material-ui/icons/Cancel";
// Styles
import formStyle from "../../../../assets/jss/custom-components/formStyle";

import {NOTIFICATION_DURATION} from "../../../../variables/coreConstants";
import {
    enableComponent,
    isSuccessfulRequest
} from "../../../../utils/helpersFunctions";
import {validateSession} from "../../../../services/api";
import Snackbar from "../../../../components/Snackbar/Snackbar";
import {withTranslation} from "react-i18next";
import {exportBlockDeposit} from "../../../../services/blockDepositService";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";


class ExportBlockDeposit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disableField: false,
            notificationMessage: '',
            notification: false,
            color: 'success',
            icon: NotificationSuccessIcon,
        };
    }


    showNotification = (msj, color, icon, refresh) => {
        this.setState({
            notificationMessage: msj,
            color: color,
            icon: icon,
            notification: true,
        });

        window.setTimeout(
            function() {
                this.setState({ notification: false });

                if (refresh != null)
                    this.props.closeForm("openExport", false, false);

            }.bind(this),
            NOTIFICATION_DURATION
        );
    };

    hideNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ notification: false });
    };


    makeRequest() {
        this.setState({ isLoading: true }, () => {
            exportBlockDeposit(this.props.walletAccountId, this.props.uuid)
                .then((response) => {
                    if (isSuccessfulRequest(response)) {
                        this.showNotification(response.data.message, "primary", NotificationSuccessIcon, true);
                    } else {
                        this.setState({ isLoading: false });
                        enableComponent(this, "disableField");
                        this.showNotification(response.data.message, "danger", NotificationErrorIcon, null);
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false });
                    enableComponent(this, "disableField");
                    if (error.response) {
                        this.showNotification(error.response.data.message, "danger", NotificationFailedIcon, null);
                        validateSession(error.response, this.props.history);
                    }
                });
        });
    }



    render() {
        const { classes, t } = this.props;

        return (
            <div className={classes.formContainer}>
                <GridContainer>
                    <Backdrop className={classes.backdrop} open={this.state.isLoading} >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.rightPaper}>
                            <Button
                                color="white"
                                className={classes.buttonSpacing + " " + classes.cancelButton}
                                onClick={() => this.props.closeForm("openExport", false, false)}
                            >
                                {t('BTN_CANCEL')}
                            </Button>
                            <Button
                                color="primary"
                                className={classes.buttonSpacing}
                                onClick={() => this.makeRequest()}
                                disabled={this.state.disableField}
                            >
                                {t('BTN_SEND')}
                            </Button>
                        </div>
                    </GridItem>
                    <Snackbar
                        place="tc"
                        color={this.state.color}
                        icon={this.state.icon}
                        message={this.state.notificationMessage}
                        open={this.state.notification}
                        closeNotification={this.hideNotification}
                        close
                    />
                </GridContainer>
            </div>
        );
    }
}

ExportBlockDeposit.propTypes = {
    classes: PropTypes.object,
    uuid: PropTypes.object,
    walletAccountId: PropTypes.string,
    closeForm: PropTypes.func
};

export default withRouter(withStyles(formStyle)(withTranslation()(ExportBlockDeposit)));